



















































import { Component, Vue, Prop, Watch, namespace, State, Getter } from 'nuxt-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import xssFilters from 'xss-filters'
import { resizeImg, isExperienceEndPath } from '~/share/utils'
import { recordSearchHistory } from '~/components/tour/destination-search/utils'

const experience = namespace('experience')

@Component
export default class SearchResult extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Getter languagePath!: string

  @experience.State suggestion!: any
  @Prop({ default: () => [] }) list!: any
  @Prop({ default: () => [] }) suggest_destinations!: any
  @Prop({ default: '' }) keywords!: string
  @Prop({ default: '' }) spmModuleName!: string
  @Prop({ type: Boolean, default: false }) openNewTab!: boolean // 是否打开新的界面

  cloneDataList: any = []

  get valid() {
    return !!(this.list?.length || this.suggest_destinations?.length)
  }

  @Watch('list', { deep: true, immediate: true })
  onDataListChange(val: any) {
    this.cloneDataList = this.formatDataList(val || [])
  }

  genSuggestDestinationSpm(item: any) {
    const { keywords, city_id, country_id, poi_id } = item || {}

    if (!city_id && !country_id && !poi_id) {
      return `SearchInGlobal?ext=${encodeURIComponent(JSON.stringify({ query: keywords }))}`
    }

    let oid = ''

    if (city_id) {
      oid = `city_${city_id}`
    }

    if (country_id) {
      oid = `country_${country_id}`
    }

    if (poi_id) {
      oid = `poi_${poi_id}`
    }

    return `SearchInDestination?oid=${oid}&ext=${encodeURIComponent(JSON.stringify({ query: keywords }))}`
  }

  formatDataList(list: any) {
    const source = cloneDeep(list)

    if (source.length) {
      return source.map((item: any) => {
        item.icon = resizeImg(item.icon, 170, 170)
        item.img_url = resizeImg(item.img_url, 170, 170)

        return item
      })
    }

    return source
  }

  replacKeywordsHtml(text: string) {
    const reg = new RegExp(`${this.keywords}`, 'ig')
    const _replace = (str: string, _reg: any) => str.replace(_reg, (matchStr: string) => {
      isMatched = true
      return `<span style="color: #212121;font-weight:600;">${xssFilters.inHTMLData(matchStr)}</span>`
    })
    let isMatched = false
    let txt = ''

    if (reg.test(text)) {
      txt = _replace(text, reg)
    }

    if (!isMatched) {
      return xssFilters.inHTMLData(text)
    }

    return txt
  }

  replaceHtml(text: string | string[]) {
    const dot = '<b class="dot"></b>'

    if (this.keywords && text) {
      const reg = new RegExp(`${this.keywords}`, 'ig')
      const _replace = (str: string, _reg: any) => str.replace(_reg, (matchStr: string) => `<span style="color: #212121;font-weight:600;">${matchStr}</span>`)

      if (Array.isArray(text)) {
        const replacedText = text.map((txt: string) => {
          if (reg.test(txt)) {
            txt = _replace(txt, reg)
          }

          return txt
        })

        return replacedText.join(dot)
      }

      return _replace(text, reg)
    }

    return Array.isArray(text) ? text.join(dot) : text
  }

  getSpm(item: any, index: number, len: number) {
    const { city_id, country_id, track_info = {}, query = {} } = item || {}

    const ext = {
      ...(track_info || {}),
      city_id,
      country_id,
      poi_id: query.poi_id,
      query: this.keywords || ''
    }

    return `${this.spmModuleName}?len=${len}&idx=${index}&ext=${encodeURIComponent(JSON.stringify(ext))}`
  }

  getUnionText(textList: string[]) {
    if (!textList?.length) {
      return ''
    }

    return this.replaceHtml(textList)
  }

  clickSuggestDestination(item: any) {
    const { keywords, city_id, country_id, poi_id, deeplink } = item
    recordSearchHistory(keywords, deeplink, { city_id, country_id, poi_id })
    window.location.href = deeplink
  }

  handleClick(item: any) {
    const {
      deeplink = '',
      query = '',
      track_info = {},
      frontend_id_list = []
    } = item

    if (deeplink) {
      let noNeedNewTab = false
      let url = deeplink

      if (query) {
        if (!isExperienceEndPath(this.$route.path)) {
          noNeedNewTab = true
        }

        const { query } = this.$route

        if (query?.not_cal_destination) {
          url += '?not_cal_destination=1'
        }
      }

      if (url) {
        if (track_info?.SuggestType !== 'Activity') {
          const { country_id, city_id, poi_id = '' } = query

          recordSearchHistory(
            item.text,
            url,
            {
              ...(track_info || {}),
              country_id,
              city_id,
              poi_id,
              FrontendTree: frontend_id_list.join(',')
            }
          )
        }

        url = this.$href(url)

        if (noNeedNewTab) {
          window.location.href = url
        } else if (this.openNewTab) {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
    }
  }
}
